import React, { FC } from 'react';
import styles from '../../index.module.scss';
import { Button } from 'src/common';
import { useTranslation } from 'react-i18next';

interface IProps {
  onBackClick: () => void;
}

export const GreetMfaActivated: FC<IProps> = props => {
  const { onBackClick } = props;
  const { t } = useTranslation();

  return (
    <>
      <h2 className={styles.subTitle}>{`${t('Security.mfaAuth')} - ${t('Security.setup')}`}</h2>
      <div className={styles.content}>
        <p>{t('Security.mfaActivationGreeting', { activationStatus: t('Common.activated') })}</p>
        <Button type={'primary'} onClick={onBackClick} className={styles.buttonDone}>
          {t('Common.done')}
        </Button>
      </div>
    </>
  );
};

export default GreetMfaActivated;
